import { render } from "./OrOptions.vue?vue&type=template&id=379f62e1&ts=true"
import script from "./OrOptions.vue?vue&type=script&lang=ts"
export * from "./OrOptions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__